import { ApiAiAgents } from ".";
import { AxiosResponse } from 'axios';
import { HttpMethods } from "../httpMethods";
import { AiAgentDto } from "../../types/aiAgent";
import { Controllers, GeneralRoutes } from "../../utils/constants";
import { BaseService } from "../baseService";

export class AiAgentService extends BaseService implements ApiAiAgents {
    async getAiAgents(urlParams: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.AiAgent, "", urlParams);
    }

    async getAiAgentById(agentId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.AiAgent, '', `${agentId}`);
    }

    async createAiAgent(agent: AiAgentDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, "", null, agent);
    }

    async updateAiAgent(agent: AiAgentDto): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, GeneralRoutes.Update, null, agent);
    }

    async deleteAiAgents(agentIds: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, GeneralRoutes.Delete, null, agentIds);
    }

    async retryKnowledgeSync(agentId: string): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, `${agentId}/${GeneralRoutes.RetryKnowledgeSync}`);
    }

    async getKnowledgeSyncStatus(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Get, Controllers.AiAgent, GeneralRoutes.KnowledgeSyncStatus);
    }

    async syncAllUnsyncedKnowledge(): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, GeneralRoutes.SyncAllUnsyncedKnowledge);
    }

    async assignMcpServers(agentId: string, mcpServerIds: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, `${agentId}/mcp-servers/assign`, '', mcpServerIds);
    }

    async unassignMcpServers(agentId: string, mcpServerIds: string[]): Promise<AxiosResponse> {
        return this.invokeServiceCall(HttpMethods.Post, Controllers.AiAgent, `${agentId}/mcp-servers/unassign`, '', mcpServerIds);
    }
}
